module.exports = "../../../../platform/assets/pageMainIcon/icon-zhuangtai-3-blue.svg";